import wx from 'weixin-js-sdk';
import axios from '../common/axiosHttp.js'
import util from '../common/util.js'

var isWxReady=false;

export default {
  // 初始化SDK（核心方法）
  async initWxConfig() {
    const currentUrl = window.location.href.split('#')[0];
    try {
      var paramJson =JSON.stringify({
        url:currentUrl
      });
      
      let Base64 = require('js-base64').Base64
      let baseStr = Base64.encode(paramJson)
      // console.log('当前地址：'+currentUrl);
     const response=await axios.post(util.apiUrl.xnmlUrl+'/wxShare', baseStr);

      var data=response.data;
    wx.config({
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']
    });
          
    // SDK就绪后设置全局分享
    wx.ready(() => {
       isWxReady=true;
        // 转发给朋友（带描述）
       wx.updateAppMessageShareData({
          title: '跑兔体育赛事主页',
          desc: '跑兔体育，专注于体育赛事系统研发，致力于推动体育产业数字化转型.',
          link: currentUrl,
          imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
       });
    
        // 分享到朋友圈（无描述）
        wx.updateTimelineShareData({
          title: '跑兔体育赛事主页',
          link: currentUrl,
          imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
        });
      });
      
      
    } catch (err) {
      // alert('微信SDK初始化失败:'+JSON.stringify(err));
    }
  },

  // 转发给朋友（带描述）
  async setShareTimeline(ssid,currentUrl) {
    currentUrl='https://www.ptty.com.cn/wap/#'+currentUrl
    if(ssid===undefined||ssid.length===0){
      if(isWxReady){
      // 转发给朋友（带描述）
      wx.updateAppMessageShareData({
        title: '跑兔体育赛事主页',
        desc: '跑兔体育，专注于体育赛事系统研发，致力于推动体育产业数字化转型.',
        link: currentUrl,
        imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
      });

      // 转发朋友圈
      wx.updateTimelineShareData({
        title: '跑兔体育赛事主页',
        link: currentUrl,
        imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
      });
      return;
    }
    else{
      wx.ready(() => {
        // 转发给朋友（带描述）
      wx.updateAppMessageShareData({
        title: '跑兔体育赛事主页',
        desc: '跑兔体育，专注于体育赛事系统研发，致力于推动体育产业数字化转型.',
        link: currentUrl,
        imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
      });

      // 转发朋友圈
      wx.updateTimelineShareData({
        title: '跑兔体育赛事主页',
        link: currentUrl,
        imgUrl: 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
      });
      return;
      });
    }
    }
    if(ssid.length===0){
      return;
    }
    var paramJson =JSON.stringify({
      ssid:ssid
    });
    
    let Base64 = require('js-base64').Base64
    let baseStr = Base64.encode(paramJson)
    const response = await axios.post(util.apiUrl.xnmlUrl+'/getSsidDesc', baseStr);
    var data=response.data;
    // alert('util返回：'+JSON.stringify(data))
    if(isWxReady){
    // 转发给朋友（带描述）
    wx.updateAppMessageShareData({
      title: data.content[0].SSMC,
      desc: data.content[0].CGMC,
      link: currentUrl,
      imgUrl: data.content[0].IMGURL
    });

    // 转发朋友圈
    wx.updateTimelineShareData({
      title: data.content[0].SSMC,
      link: currentUrl,
      imgUrl: data.content[0].IMGURL
    });
  }
  else{
    wx.ready(() => {
      // 转发给朋友（带描述）
    wx.updateAppMessageShareData({
      title: data.content[0].SSMC,
      desc: data.content[0].CGMC,
      link: currentUrl,
      imgUrl: data.content[0].IMGURL
    });

    // 转发朋友圈
    wx.updateTimelineShareData({
      title: data.content[0].SSMC,
      link: currentUrl,
      imgUrl: data.content[0].IMGURL
    });
    });
  }
  },
};


// WEBPACK FOOTER //
// ./src/common/wxShare.js